import type { DeskSdkConfig } from '../types';

const Config: DeskSdkConfig = {
  path: 'desk.mapado.com',
  scheme: 'https',
  unitOfWorkEnabled: true,
};

export default Config;
